import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setValueWithExpiry(key: string, value: any, expirySeconds: number): void {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + expirySeconds * 1000 // Convert seconds to milliseconds
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getValueWithExpiry(key: string): any {
    const itemString = localStorage.getItem(key);
    if (!itemString) {
      return null;
    }
    const item = JSON.parse(itemString);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
}
